/* eslint-disable @typescript-eslint/no-explicit-any */

import { MessageType, ResponseCode, ResponseMessage } from './response-code'

type Props = {
  code: ResponseCode
  data?: any
  message?: ResponseMessage
  status: number
}

export type ErrorHandler = ResponseMessage & {
  code: ResponseCode
  onConfirm?: (() => void) | null
  data?: {
    [key: string]: string
  }
}

const DEFAULT_MESSAGE = '오류가 발생했습니다.'

export class HttpError extends Error {
  code: ResponseCode
  status: number
  handler: ErrorHandler

  constructor({ code, data, message, status }: Props) {
    super(message?.content ?? DEFAULT_MESSAGE)
    this.name = 'HttpError'
    this.code = code
    this.status = status
    this.handler = {
      code,
      ...(message ?? {
        type: MessageType.TOAST,
        content: DEFAULT_MESSAGE,
      }),
      data,
    }
  }
}

export const isHttpError = (error: unknown): error is HttpError =>
  error instanceof HttpError
